import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { lookupUser as lookupUserAction } from '../../actions/lookup';
import { sendPasswordlessEmail as sendPasswordlessEmailAction } from '../../actions/passwordless';
import PreAuthPage from './preAuthPage';

const _mapStateToProps = ({ lookup, frontend, status, authentication }) => ({
    auth0RedirectUrl: lookup.auth0RedirectUrl,
    isSocialUser: lookup.socialConnected,
    isSoftAccount: frontend.showModal,
    isNewAccount: status.signUpSecondStep,
    recaptcha3PublicKey: authentication.recaptcha3PublicKey,
    disableRecaptcha3: authentication.disableRecaptcha3,
    featureFlags: authentication.featureFlags,
});

const _mapDispatchToProps = {
    sendPasswordlessEmailAction,
    lookupUserAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(PreAuthPage),
);
